var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:this.$store.state.cssClassCardOverviewState},[_c('Cards')],1),_c('CardIntro')],1)}
var staticRenderFns = []

export { render, staticRenderFns }